import { create } from 'superstruct'
import { PAYMENT_METHOD_TYPES, PROVIDERS } from '../constants.js'
import { BuyOrder } from '../schema/order.js'
import { joinUrl, omitUndefinedValues } from '../utils.js'
import { createPaymentMethodValidator } from '../payment-method.js'
import { ENABLED_ASSETS, PAYMENT_METHODS } from './constants.js'

const fromProviderToExodusAsset = ({
  assets_ = ENABLED_ASSETS,
  assetsModule,
  assetSymbol,
  networkName,
}) =>
  assetsModule.getAsset(assets_[`${assetSymbol}_${networkName?.replace(' ', '_')}`.toLowerCase()])

const fromExodusToProviderPaymentMethod = (paymentMethod, parameters = {}) => {
  const providerPaymentMethod = [...PAYMENT_METHODS.values()]
    .flat()
    .find(createPaymentMethodValidator({ ...parameters, type: paymentMethod }))

  return providerPaymentMethod?.id
}

const fromProviderToExodusOrder = (order, assetsModule, assets_ = ENABLED_ASSETS) => {
  const {
    asset_symbol: assetSymbol,
    fromAmount,
    assetName,
    topup_summary: {
      amount_breakdown: { fee: feeDetails, total } = {},
      asset_exchange_rate: { fiatAmount } = {},
      asset_quantity: { quantity = 0 } = {},
      transaction_hash: txId,
      blockchain_address: { value: walletAddress } = {},
    } = {},
  } = order
  const asset = fromProviderToExodusAsset({
    assets_,
    assetsModule,
    assetSymbol,
    networkName: assetsModule.getAsset(assetName)?.displayNetworkName,
  })
  const totalAmount = Number(total?.value) || 0
  const providerFee = Number(feeDetails?.value) || 0

  return create(
    {
      createdAt: new Date(order.create_time),
      extraFee: 0,
      fee: providerFee,
      from: {
        amount: totalAmount || fromAmount,
        asset: total?.currency_code || 'USD',
      },
      id: order.id,
      networkFee: 0,
      paymentMethod: fromExodusToProviderPaymentMethod(PAYMENT_METHOD_TYPES.paypal),
      paymentMethodType: PAYMENT_METHOD_TYPES.paypal,
      provider: PROVIDERS.paypal,
      providerId: order.id,
      rate: Number(fiatAmount?.value) || 0,
      status: order.status,
      to: {
        amount: Number(quantity),
        asset: asset?.name,
      },
      totalFee: providerFee,
      txId,
      updatedAt: new Date(order.update_time),
      walletAddress,
    },
    BuyOrder
  )
}

const getRedirectUrl = ({ finalUrl, orderId, origin }) =>
  joinUrl(
    finalUrl,
    `?${new URLSearchParams(omitUndefinedValues({ orderId, origin, provider: PROVIDERS.paypal }))}`
  )

const fromExodusToProviderOrder = (
  {
    toAsset,
    fromAmount,
    walletAddress,
    countryCode,
    regionCode,
    fromAmountCurrency = 'USD',
    channel = 'WEB',
    receiverType = 'BLOCKCHAIN_ADDRESS',
    ...rest
  },
  assetsModule
) => {
  const asset = assetsModule.getAsset([[toAsset].flat().pop()])
  return {
    intent: 'TOPUP',
    asset_symbol: asset?.displayTicker,
    blockchain: asset?.displayNetworkName,
    country_code: countryCode,
    region: regionCode,
    fiat_amount: {
      value: fromAmount,
      currency_code: fromAmountCurrency,
    },
    receiver: {
      type: receiverType,
      id: walletAddress,
    },
    partner: {
      redirect_url: getRedirectUrl(rest),
      channel,
    },
  }
}

const paypalAdapter = {
  fromExodusToProviderOrder,
  fromExodusToProviderPaymentMethod,
  fromProviderToExodusAsset,
  fromProviderToExodusOrder,
}

export default paypalAdapter
